import { useState } from 'react'
import { useMediaQuery } from '@uidotdev/usehooks'
import TinySlider from 'tiny-slider-react'
import 'tiny-slider/dist/tiny-slider.css'
import { CAROUSEL_CONFIG, VIRTUAL_TOUR_TABS } from '../../constant'
import TourController from '../tour-controller'
import classNames from 'classnames'
import './styles.scss'
import ExteriorAngle from '../exterior-angle'
import CarouselController from '../carousel-controller'

function Exterior({ slides, className = '', onTabChange }) {
  const isPhoneScreen = useMediaQuery('screen and (max-width: 1080px)')
  const [carousel, setCarousel] = useState(null)
  const onGoTo = (dir) => carousel.slider.goTo(dir)

  return (
    <div
      className={classNames({
        [className]: true,
        'virtual-tour-exterior': true,
      })}
    >
      <TinySlider
        settings={{ ...CAROUSEL_CONFIG, mode: 'gallery', loop: true }}
        ref={(ts) => setCarousel(ts)}
      >
        {slides.map(({ image, hotspots }, index) => (
          <ExteriorAngle
            key={`exterior-angle-slide-${index}`}
            hotspots={hotspots || []}
            imgSrc={isPhoneScreen ? image.sm : image.lg}
          />
        ))}
      </TinySlider>

      <CarouselController
        className="exterior-position"
        onClick={(dir) => onGoTo(dir)}
      />

      <TourController
        activeTab={VIRTUAL_TOUR_TABS.EXTERIOR}
        setTab={onTabChange}
      />
    </div>
  )
}

export default Exterior
